import {
  CONTACTS_REQUEST, CONTACTS_REQUEST_SUCCESS, CONTACTS_REQUEST_FAILED
} from "../actions/contacts_actions";

const initialState = {
  phones: [],
  emails: [],
  socials: [],
  requestProgress: false,
  requestFailed: false,
}

export const contactsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONTACTS_REQUEST: {
      return {
        ...state,
        requestProgress: true,
        requestFailed: false,
      }
    }
    case CONTACTS_REQUEST_SUCCESS: {
      return {
        ...state,
        phones: [...action.phones],
        emails: [...action.emails],
        socials: [ ...action.socials],
        requestProgress: false,
        requestFailed: false,
      }
    }
    case CONTACTS_REQUEST_FAILED: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: true,
      }
    }
    default: return state;
  }
}
